<template>
  <v-card class="comentarios-alumno-chat" flat>
    <v-card-text class="comentarios-lista pa-4" style="max-height: 360px; overflow-y: auto;">
      <div v-if="cargando && !comentarios.length" class="text-center py-6">
        <v-progress-circular indeterminate color="primary" size="28"></v-progress-circular>
      </div>
      <div v-else-if="!comentarios.length" class="text-center text-grey py-4">
        <v-icon>mdi-chat-outline</v-icon>
        <p class="mt-2 mb-0">No hay comentarios en este chat</p>
      </div>
      <v-list v-else two-line>
        <v-list-item
          v-for="comentario in comentarios"
          :key="'comentario-' + comentario.id"
          class="mb-3"
        >
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ comentario.nombre_usuario }}
            </v-list-item-title>
            <v-list-item-subtitle class="text-xs grey--text">
              {{ formatearFecha(comentario.fecha_hora) }}
            </v-list-item-subtitle>
            <div class="mt-2 text-body2">
              {{ comentario.comentario }}
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-text class="pa-4">
      <v-textarea
        v-model="nuevoComentario"
        outlined
        dense
        label="Escribe un comentario..."
        rows="3"
        placeholder="Escribe tu comentario aqui"
        counter="500"
        maxlength="500"
        hide-details="auto"
        @keydown.ctrl.enter="agregarComentario"
        @keydown.meta.enter="agregarComentario"
      ></v-textarea>

      <div class="d-flex justify-end mt-2">
        <v-btn
          small
          outlined
          @click="nuevoComentario = ''"
          :disabled="!nuevoComentario.trim() || cargando"
        >
          Limpiar
        </v-btn>
        <v-btn
          small
          color="primary"
          class="ml-2"
          @click="agregarComentario"
          :loading="cargando"
          :disabled="!nuevoComentario.trim() || cargando"
        >
          <v-icon small class="mr-1">mdi-send</v-icon>
          Agregar
        </v-btn>
      </div>
    </v-card-text>
    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import validarErrores from '@/mixins/validarErrores'

export default {
  name: 'ComentariosAlumnoChat',
  components: { Alerta },
  mixins: [validarErrores],
  props: {
    usuario: { type: String, required: true },
    escuela: { type: [String, Number], required: true },
    idAlumno: { type: [String, Number], required: true },
  },
  data () {
    return {
      comentarios: [],
      nuevoComentario: '',
      cargando: false,
    }
  },
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
  },
  watch: {
    usuario: {
      handler () {
        this.cargarComentarios()
      },
      immediate: true,
    },
  },
  methods: {
    cargarComentarios () {
      if (!this.usuario) return
      this.cargando = true
      this.$http
        .post('/api/comentarios-chat-alumno.list', {
          usuario: this.usuario,
          escuela: Number(this.escuela),
        })
        .then((response) => {
          this.comentarios = response.data || []
        })
        .catch((error) => {
          const mensaje = (error.body && error.body.message) ||
            (error.response && error.response.data && error.response.data.message) ||
            'Error al cargar comentarios'
          if (typeof this.validarError === 'function') this.validarError(mensaje)
        })
        .finally(() => {
          this.cargando = false
        })
    },
    agregarComentario () {
      const texto = (this.nuevoComentario || '').trim()
      if (!texto || !this.idAlumno) return

      const u = this.getdatosUsuarioERPERP || {}
      this.cargando = true
      this.$http
        .post('/api/comentarios-chat-alumno', {
          usuario: this.usuario,
          escuela: Number(this.escuela),
          id_alumno: this.idAlumno,
          comentario: texto,
          nombre_usuario: u.nombre_completo || ((u.nombre_usuario || '') + ' ' + (u.apellido_usuario || '')).trim() || 'Usuario',
          idperfil: u.idpuesto,
          perfil: u.puesto,
        })
        .then(() => {
          this.nuevoComentario = ''
          this.cargarComentarios()
        })
        .catch((error) => {
          const mensaje = (error.body && error.body.message) ||
            (error.response && error.response.data && error.response.data.message) ||
            'Error al agregar el comentario'
          if (typeof this.validarError === 'function') this.validarError(mensaje)
          this.cargando = false
        })
    },
    formatearFecha (fecha) {
      if (!fecha) return ''
      try {
        const date = new Date(fecha)
        return date.toLocaleString('es-MX', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      } catch (e) {
        return fecha
      }
    },
  },
}
</script>

<style scoped>
.comentarios-lista {
  background-color: #f9f9f9;
}
.comentarios-lista .v-list-item {
  border-left: 3px solid #e0e0e0;
  padding-left: 12px;
}
</style>